import { useMap } from '@vis.gl/react-google-maps';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { type Marker, MarkerClusterer } from '@googlemaps/markerclusterer';
import MarkerWithInfowindow from "./marker";

type Props = {
    results: Result[],
    setShowInfo: any, onMouseEnter: any, showInfo: any, onMouseLeave: any
}

type Result = {
    item:  {
        id: number | {raw: number},
        thumbnail_uri: string,
        address: any,
        name: string
        resultHref: string,
        category_code: string
    },
    lat: number,
    lng: number,
    id: number
}

export const ClusteredMarkers = ({ results, setShowInfo, onMouseEnter, showInfo, onMouseLeave }: Props) => {
    const [markers, setMarkers] = useState<{ [key: string]: Marker }>({});

    const map = useMap();
    const clusterer = useMemo(() => {
        if (!map) return null;

        return new MarkerClusterer({ map });
    }, [map]);

    useEffect(() => {
        if (!clusterer) return;

        clusterer.clearMarkers();
        clusterer.addMarkers(Object.values(markers));
    }, [clusterer, markers]);

    const setMarkerRef = useCallback((marker: Marker | null, key: string) => {
        setMarkers(markers => {
            if ((marker && markers[key]) || (!marker && !markers[key]))
                return markers;

            if (marker) {
                return { ...markers, [key]: marker };
            } else {
                const { [key]: _, ...newMarkers } = markers;

                return newMarkers;
            }
        });
    }, []);

    return (
        <>
            {results.map((r: Result, index) => (
                <MarkerWithInfowindow key={`MarkerWithInfowindow-${index}-${typeof r.item.id === 'object' ? r.item.id.raw : r.item.id}`} data={r}
                    setShowInfo={setShowInfo} showInfo={showInfo} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} setMarkerRef={setMarkerRef}
                />
            ))}
        </>
    );
};